/* eslint-disable import/extensions */
/* eslint-disable func-names */
/* eslint-disable no-param-reassign */

import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { persistedState, saveState } from './persisted.store.js';
import rootReducer from './reducers';
import { USER_LOGOUT } from './user/constants';

let middleWares;

switch (process.env.NODE_ENV) {
  case 'development':
    middleWares = composeWithDevTools(applyMiddleware(thunk));
    break;
  case 'production':
  default:
    middleWares = applyMiddleware(thunk);
}

const appReducer = (state, action) => {
  if (action.type === USER_LOGOUT) {
    sessionStorage.clear();
    localStorage.clear();
    state = undefined;
  }

  return rootReducer(state, action);
};

export default function configureStore() {
  const store = createStore(
    appReducer,
    persistedState, // second argument overrides the initial state
    middleWares
  );

  // add a listener that will be invoked on any state change
  store.subscribe(() => {
    saveState(store.getState());
  });

  return store;
}
